import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../custom/app-component-generic/app-component-generic.component';
import { TableGenericComponent } from '../custom/table-generic/table-generic.component';

import { LocaleService } from '../../services/locale.service';
import { DataService } from '../../services/data.service';
import { AuthService } from '../../services/auth.service';
import { AvanzaPraticheService } from '../../services/avanza-pratiche.service';

import { GenericFilterParameter } from '../../models/generic-comunication-cmp';
import { GenericExternalCommandType } from '../../models/generic-external-command';
import { PraticheTableField } from '../../models/pratiche-table-field';
import { GenericTableField } from '../../models/generic-table-field';
import { PraticheType } from '../../models/pratiche';

@Component({
	selector: 'app-pratiche',
	templateUrl: './pratiche.component.html',
	styleUrls: ['./pratiche.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PraticheComponent extends AppComponentGenericComponent implements OnInit {
	@ViewChild('mw') mw: any;
	modalInput: any;

	numPratiche: any = 0;
	idStatoAttuale: number;

	//	Table
	tableFields: PraticheTableField;
    headerFields: GenericTableField[];
    footerFields: GenericTableField[];
    ngClassRow = ""

	//	FilterBox
	comune: any = {};
	comuneSync: Subscription;

	praticheFilteredSubmit: any[] = [];
	praticheTotal: PraticheType;
	praticheFiltered: any[] = [];
	praticheSync: Subscription;

	pagamenti: any[] = [];
	pagamentiSync: Subscription;
	emissioniSync: Subscription;
	activeFlowSync: Subscription;
	externCommands: Map<string, GenericExternalCommandType> = null;

	constructor(private cdr: ChangeDetectorRef, protected dataService: DataService, private avanzaPraticheService: AvanzaPraticheService) {
		super(dataService, 'pratiche');
    }

	ngOnInit() {
		this.tableFields = new PraticheTableField();
		this.headerFields = this.tableFields.getHeader();
		this.footerFields = this.tableFields.getFooter();

		this.parametri = new GenericFilterParameter();
		this.parametri.setTypeFilter("pratiche");
		this.parametri.setTitleBox("Lista Pratiche");
		this.parametri.setNumFilteredTxt("Pratiche");
		this.externCommands = new Map();
		if(this.checkPermission('pratiche','write')){
			let avanzaPraticheCommand = new GenericExternalCommandType();
			avanzaPraticheCommand.setAllValue("avanza-pratiche", "arrow_forward", "avanza-pratiche", "Avanza Pratiche", true);
			this.externCommands.set('avanza-pratiche', avanzaPraticheCommand);
			let esportaPraticheCommand = new GenericExternalCommandType();
			esportaPraticheCommand.setAllValue("", "cloud_download", "esporta-pratiche", "Esporta Pratiche", false);
			this.externCommands.set('esporta-pratiche', esportaPraticheCommand);
			this.parametri.setWritePermission(true);
		}
		this.parametri.setExternCommands(this.externCommands);
		this.updateParametri();

		this.modalInput = {
			size: 'modal-95',
			title: 'Titolo',
			subtitle: 'sottotitolo',
			data: {
				id: 0,
				person: null,
				id_prat: null,
				reset: false,
			}
		};
		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			comune => {
				this.comune = comune
			});
		this.activeFlowSync = this.dataService.activeFlow$.subscribe(
			activeFlow => {
				this.parametri.setActiveFlow(activeFlow);
				this.updateParametri();
				console.log('PRATICHE|activeFlow:', activeFlow);
			});
		this.emissioniSync = this.dataService.emissioni$.subscribe(
			emissioni => {
				this.parametri["emissioni"] = emissioni;
				this.updateParametri();
				console.log('PRATICHE|emissioni:', emissioni);
			});
		this.praticheSync = this.dataService.pratiche$.subscribe(
			pratiche => {
				for(let pratica of pratiche){
					pratica["nominativo"] = "";
					if(pratica['cognome']){
						pratica["nominativo"] = pratica['cognome'];
						if(pratica['nome']){
							pratica["nominativo"] += ' ';
						}
					}
					if(pratica['nome']){
						pratica["nominativo"] += pratica['nome'];
					}
				}
				this.parametri.setDataArraySource(pratiche);
				this.updateParametri();
				console.log('PRATICHE|pratiche:', pratiche, this.praticheFiltered);
			});
		this.pagamentiSync = this.dataService.pagamenti$.subscribe(
			pagamenti => {
				this.pagamenti = pagamenti;
				//this.calcSummedValue();
				console.log('PRATICHE|pagamenti:', this.pagamenti);
			});
	}

	ngOnChanges(changes: any){
		console.log('CMP|PRATICHE - CHANGE',  changes);
		if(changes.parametri){
			this.updateParametri();
		}
	}

	preparePratiche(pratiche: any[]){
		//console.log("PRATICHE|preparePratiche pratiche", pratiche);
		let praticheLocal: PraticheType[] = [];
		let praticheLocalSubmit: any[] = [];
		let praticaLocal = new PraticheType(this.dataService.getCommon().getLocale());
		let praticaLocalSubmit: any = {};

		if(pratiche.length){
			for(let pratica of pratiche){
				praticaLocalSubmit = {};

				praticaLocal.setFieldValue("uid", pratica['id']);
				praticaLocalSubmit['uid'] = praticaLocal.getFieldString('uid');

				praticaLocal.setFieldValue("id_prat", pratica['id_prat']);
				praticaLocalSubmit['id_prat'] = praticaLocal.getFieldString('id_prat');

				praticaLocal.setFieldValue("anagrafica_id", pratica['anagrafica_id']);
				praticaLocalSubmit['anagrafica_id'] = praticaLocal.getFieldString('anagrafica_id');

				praticaLocal.setFieldValue("comune_id", pratica['comune_id']);
				praticaLocalSubmit['comune_id'] = praticaLocal.getFieldString('comune_id');

				praticaLocal.setFieldValue("emissione", pratica['emissione']);
				praticaLocalSubmit['emissione'] = praticaLocal.getFieldString('emissione');

				praticaLocal.setFieldValue("stato_id", pratica['stato_id']);
				praticaLocalSubmit['stato_id'] = praticaLocal.getFieldString('stato_id');

				praticaLocal.setFieldValue("stato", pratica['stato']);
				praticaLocalSubmit['stato'] = praticaLocal.getFieldString('stato');

				if(pratica['cognome']){
					praticaLocal.setFieldValue("nominativo", pratica['cognome']);
					if(pratica['nome']){
						praticaLocal.setFieldValue("nominativo", praticaLocal.getFieldValue("nominativo") + ' ');
					}
				}
				if(pratica['nome']){
					praticaLocal.setFieldValue("nominativo", praticaLocal.getFieldValue("nominativo") + pratica['nome']);
				}
				praticaLocalSubmit['nominativo'] = praticaLocal.getFieldString('nominativo');

				praticaLocal.setFieldValue("notifica_data", pratica['notifica_data']);
				praticaLocalSubmit['notifica_data'] = praticaLocal.getFieldString('notifica_data');

				praticaLocal.setFieldValue("notifica_scadenza", pratica['notifica_scadenza']);
				praticaLocalSubmit['notifica_scadenza'] = praticaLocal.getFieldString('notifica_scadenza');

				praticaLocal.setFieldValue("totale_pagato", pratica['totale_pagato']);
				praticaLocalSubmit['totale_pagato'] = praticaLocal.getFieldString('totale_pagato');

				praticaLocal.setFieldValue("totale_dovuto", pratica['totale_dovuto']);
				praticaLocalSubmit['totale_dovuto'] = praticaLocal.getFieldString('totale_dovuto');

				praticaLocal.setFieldValue("totale_residuo", pratica['totale_dovuto'] - pratica['totale_pagato']);
				praticaLocalSubmit['totale_residuo'] = praticaLocal.getFieldString('totale_residuo');

				praticheLocal.push(praticaLocal);
				praticheLocalSubmit.push(praticaLocalSubmit);
			}
		}
		//console.log("preparePratiche", pratiche, praticheLocal, praticheLocalSubmit);
		return praticheLocalSubmit;
	}

	calcSummedValue(){
		//console.log("PRATICHE|calcSummedValue");
		let totale_dovuto: number = 0.00;
		let totale_pagato: number = 0.00;
		this.numPratiche = 0;
		this.praticheFilteredSubmit = [];
		this.praticheTotal = new PraticheType(this.dataService.getCommon().getLocale());
		for(let pratica of this.praticheFiltered){
			this.numPratiche++;
			totale_dovuto = totale_dovuto + Number(pratica.totale_dovuto);
			totale_pagato = totale_pagato + Number(pratica.totale_pagato);
		}
		this.praticheTotal.setFieldValue('totale_dovuto', totale_dovuto);
		this.praticheTotal.setFieldValue('totale_pagato', totale_pagato);
		this.praticheTotal.setFieldValue('totale_residuo', totale_dovuto - totale_pagato);
		if(this.praticheFiltered.length){
			this.praticheFilteredSubmit = this.preparePratiche(this.praticheFiltered);
		}
	}

	avanzaPratiche(praticheFiltered: any[], uid: number = null) {
		let nextStep = this.dataService.avanzaPratiche(praticheFiltered, this.idStatoAttuale, uid);
		this.modalInput.size = 'medium-modal';
		this.modalInput.title = 'Avanza Pratiche';
		this.modalInput['data'] = nextStep;
		if(nextStep.numPrat > 1){
			this.modalInput['subtitle'] = 'Pratiche: ' + nextStep.numPrat;
		}else{
			this.modalInput['subtitle'] = 'Pratica: ' + nextStep.numPrat;
		}
		console.log('modal input', nextStep, this.modalInput);
	}

	getModalOutput(event: any) {
		console.log("PRATICHE|avanzaPratiche", event)
	}

	apriModifica(pratica: any){
		this.modalInput = {
			size: 'large-modal',
			title: 'Pratica: ' + pratica.id_prat,
			subtitle: 'Contribuente: ' + pratica.anagrafica_id,
			data: {
				pratica: pratica,
			}
		};
		this.mw.show('pratica-view', this.modalInput);
		console.log('pratica-view', pratica);
	}

    apriNuovo(){
    }

	updateParametri(){
		//console.log('CMP|PRATICHE - CHANGE PRATICHE UPDATEPARAMETRI', this.parametri);
		this.parametriString = this.parametri.generateParametriToString();
		this.cdr.markForCheck();
		//console.log('CHANGE PRATICHE UPDATEPARAMETRISTRING', this.parametriString);
	}

	manageEventFilterBox($event){
		//console.log("PRATICHE|manageEventFilterBox", $event);
		if($event){
			switch($event.type){
				case 'filterResult':
					this.praticheFiltered = $event.data;
					this.calcSummedValue();
					this.tableFields.generateFooterRow(this.praticheTotal);
					this.footerFields = this.tableFields.getFooter();

					if(this.checkPermission('pratiche','write')){
						let externCommandLocal = new GenericExternalCommandType();
						//console.log("PRATICHE|idStatoSelected", this.idStatoAttuale, this.praticheFiltered.length);
						if(this.idStatoAttuale && this.praticheFiltered.length){
							externCommandLocal.setAllValue("avanza-pratiche", "arrow_forward", "avanza-pratiche", "Avanza Pratiche", false);
						}else{
							externCommandLocal.setAllValue("avanza-pratiche", "arrow_forward", "avanza-pratiche", "Avanza Pratiche", true);
						}
						//console.log("PRATICHE|externCommandLocal", externCommandLocal);
						this.externCommands.set('avanza-pratiche', externCommandLocal);
					}
					break;
				case 'action':
					let dataCommand = $event.data;
					let codeCommand = dataCommand.code;
					let textCommand = dataCommand.text;
					let typeCommand = dataCommand.type;
					switch(typeCommand) {
						case 'avanza-pratiche':
							this.avanzaPratiche(this.praticheFiltered);
							break;
						case 'esporta-pratiche':
							this.exportCsv();
							break;
					}
					//console.log("PRATICHE|action", this.modalInput, this.praticheFiltered, this.idStatoAttuale);
					if (codeCommand.length) {
						this.mw.show(codeCommand, this.modalInput);
					}
					break;
				case 'idStatoSelected':
					//console.log("PRATICHE|idStatoSelected");
					this.idStatoAttuale = $event.data;
					if(this.checkPermission('pratiche','write')){
						let externCommandLocal = new GenericExternalCommandType();
						//console.log("PRATICHE|idStatoSelected", this.idStatoAttuale, this.praticheFiltered.length);
						if(this.idStatoAttuale && this.praticheFiltered.length){
							externCommandLocal.setAllValue("avanza-pratiche", "arrow_forward", "avanza-pratiche", "Avanza Pratiche", false);
						}else{
							externCommandLocal.setAllValue("avanza-pratiche", "arrow_forward", "avanza-pratiche", "Avanza Pratiche", true);
						}
						//console.log("PRATICHE|externCommandLocal", externCommandLocal);
						this.externCommands.set('avanza-pratiche', externCommandLocal);
						//console.log("PRATICHE|externCommands", this.externCommands);
						this.parametri.setWritePermission(true);
					}
					this.parametri.setExternCommands(this.externCommands);
					this.updateParametri();
					break;
				default:
					console.log("PRATICHE|type non riconosciuto!");
			}
		}
	}

	exportCsv() {
		let filename = "pratiche";
		let data = [];
		for (let pratica of this.praticheFilteredSubmit) {
			let item = {}
			item['ID'] = pratica.id_prat ? pratica.id_prat : "" ;
			item['Emissione'] = pratica.emissione ? pratica.emissione : "";
			item['Stato'] = pratica.stato ? pratica.stato : "";
			item['Nominativo'] = pratica.nominativo ? pratica.nominativo : "";
			item['Data Notifica'] = pratica.notifica_data ? pratica.notifica_data : "";
			item['Data Scadenza'] = pratica.notifica_scadenza ? pratica.notifica_scadenza : "";
			item['Totale Pratica'] = pratica.totale_dovuto ? pratica.totale_dovuto : "";
			item['Pagato'] = pratica.totale_pagato ? pratica.totale_pagato : "";
			item['Residuo'] = pratica.totale_residuo ? pratica.totale_residuo : "";
			data.push(item);
		}
		this.dataService.exportCsv(filename,data);
	}

	ngOnDestroy() {
		this.comuneSync.unsubscribe();
		this.activeFlowSync.unsubscribe();
		this.emissioniSync.unsubscribe();
		this.praticheSync.unsubscribe();
	}
}
